export default {
  candidates: process.env.REACT_APP_CANDIDATES_URL,
  companies: process.env.REACT_APP_COMPANIES_URL,
  farming: process.env.REACT_APP_FARMING_URL,
  workforce: process.env.REACT_APP_WORKFORCE_URL,
  staffing: process.env.REACT_APP_STAFFING_URL,
  scheduler: process.env.REACT_APP_SCHEDULER_URL,
};
